import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import swal from 'sweetalert2';
import { mapStateToPropsWrapper, verificationProps } from '../../CaptureErreurs';
import CardPrelevement from './CardPrelevement';
import CardMandatEnCours from './CardMandatEnCours'
import Card from '../../Card';
import * as HttpStatus from '../../../App_Data/HttpStatus';
import * as ProAct from '../../../Actions/ProActions';
import { modifierModePrl, obtenirProprietaire } from '../../../App_Code/API';


const ModifierModePrl = ({
    ALaDemande, AutoMensuel, AutoExigibilite, ModePrl, stateMode, setMode, sendModif,
}) => (
    <Card Titre="Mode de prélèvement">
        <div className="d-flex justify-content-center">
            <div>
            <div className="custom-control custom-radio" hidden={!AutoMensuel}>
                    <input type="radio" id="modePrl2" name="modePrl" className="custom-control-input" value={2} checked={stateMode === 2} onChange={() => { setMode(2); }} />
                    <label className="custom-control-label" htmlFor="modePrl2"> Automatique mensualisé</label>
                </div>
                <div className="custom-control custom-radio" hidden={!AutoExigibilite}>
                    <input type="radio" id="modePrl1" name="modePrl" className="custom-control-input" value={1} checked={stateMode === 1} onChange={() => { setMode(1); }} />
                    <label className="custom-control-label" htmlFor="modePrl1"> Automatique à l&apos;exigibilité</label>
                </div>
                <div className="custom-control custom-radio" hidden={!ALaDemande}>
                    <input type="radio" id="modePrl3" name="modePrl" className="custom-control-input" value={3} checked={stateMode === 3} onChange={() => { setMode(3); }} />
                    <label className="custom-control-label" htmlFor="modePrl3"> Manuel à la demande</label>
                </div>
                <div className="col text-center">
                    <button className={ModePrl === stateMode ? 'btn btn btn-secondary mt-4' : 'btn btn btn-success mt-4'} onClick={() => { sendModif(); }} disabled={ModePrl === stateMode}>
                        Valider
                    </button>
                </div>
            </div>
        </div>
        <div className="alert alert-info w-100 mt-4 mb-0" role="alert">
            <i className="fas fa-info-circle" />
            <span className="ml-2">Les modifications seront effectives à compter de votre prochain appel de fonds.</span>
        </div>
    </Card >
);

const ModifPrlVisible = (ALaDemande, AutoMensuel, AutoExigibilite) => {
    let NbModeDispo = 0;
    if (ALaDemande) NbModeDispo += 1;
    if (AutoMensuel) NbModeDispo += 1;
    if (AutoExigibilite) NbModeDispo += 1;

    return NbModeDispo > 1;
};

class PageGererPrelevement extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ModePrl: this.props.Mandat.ModePrl,
        };
    }

    componentWillMount() {
        //Mise a jour du pro dès qu'on arrive sur la page
        obtenirProprietaire().then((pro) => {
            this.props.actions.proAjout(pro);
        })
    }
    
    setMode = (value) => {
        this.setState({ ModePrl: value });
    }

    EnvoyerModification = () => {
        if (this.state.ModePrl <= 0 || this.state.ModePrl === this.props.Mandat.ModePrl) return;

        modifierModePrl(this.state.ModePrl).then((response) => {
            if (!response) return;
            if (response.status === HttpStatus.OK) {
                swal('Succès', 'Votre modification à bien été prise en compte et sera effective lors de votre prochain appel de fonds.', 'success');
                obtenirProprietaire().then((pro) => {
                    this.props.actions.proAjout(pro);
                });
                this.props.history.push('/MesInformations');
            } else {
                const footer =
                    response.data && response.data.Message ? response.data.Message.replace(/["]+/g, '') : '';
                swal({
                    type: 'error',
                    title: 'Erreur',
                    text: "Une erreur s'est produite lors de la modification du mode de prélèvement.",
                    footer,
                });
            }
        });
    };

    render() {
        const { ModePrl, Mandat, SignElecMandatOk } = this.props;

        return (
            <div className="row">
                <div className="col-12 col-lg-6">
                    <CardPrelevement PageGererPrelevement />
                    <CardMandatEnCours Mandat={Mandat} Link={this.props.history} SignElecOk={SignElecMandatOk} />
                </div>
                <div className="col-12 col-lg-6">
                    { ModifPrlVisible(ModePrl.ALaDemande, ModePrl.AutoMensuel, ModePrl.AutoExigibilite)
                        ? <ModifierModePrl {...ModePrl} {...Mandat} stateMode={this.state.ModePrl} setMode={this.setMode} sendModif={this.EnvoyerModification} />
                        : null }
                </div>
                <div className="alert alert-light col-12" role="alert">
                    <i className="fas fa-info-circle" />
                    <span className="ml-2">Si vous souhaitez mettre fin à tout prélèvement, veuillez nous adresser un courrier de résiliation de mandat.</span>
                </div>
            </div>
        );
    }
}
PageGererPrelevement.displayName = 'PageGererPrelevement';
PageGererPrelevement.requiredProps = [
    'ModePrl', // Mode prélèvement du syndic
    'Mandat', // Mandat du propriétaire
];

function mapStateToProps({
    SynStore: {
        Syn: { ModePrl, SignElecMandatOk },
    },
    ProStore: {
        Pro: { Mandat },
    },
}) {
    return { ModePrl, SignElecMandatOk, Mandat };
}

function mapDispatchToProps(dispatch) {
    return { actions: bindActionCreators(ProAct, dispatch) };
}

export default connect(mapStateToPropsWrapper(mapStateToProps), mapDispatchToProps)(verificationProps(PageGererPrelevement));



// WEBPACK FOOTER //
// ./src/components/MesInfos/Prelevement/PageGererPrelevement.js